import { render, staticRenderFns } from "./VideoShareMenu.vue?vue&type=template&id=0fe40b6b&scoped=true"
import script from "./VideoShareMenu.vue?vue&type=script&lang=js"
export * from "./VideoShareMenu.vue?vue&type=script&lang=js"
import style0 from "./VideoShareMenu.vue?vue&type=style&index=0&id=0fe40b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe40b6b",
  null
  
)

export default component.exports